import React, { FC, useState } from 'react';
import { Dropdown, DropdownItem, DropdownList } from '@cokitchen/cokitchen-components';
import { ArrowDownIcon } from 'cokitchen-icons';
import Input, { CurrencyInputProps } from 'react-currency-input-field';
import './styles.scss';
import { weightMeasurement } from 'utils/constants';
import { ENUM_UNIT } from 'models/common.model';

type Props = Omit<CurrencyInputProps, 'onChange' | 'onValueChange'> & {
  label?: string;
  className?: string;
  onChange?: (value: string) => void;
  error?: string;
  hasUnit?: boolean;
  onUnitChange?: (value: ENUM_UNIT) => void;
  unitValue?: string;
  hideCurrency?: boolean;
  unitOptions?: {
    name: string;
    value: ENUM_UNIT;
  }[];
  disableUnit?: boolean;
  explicitRender?: boolean;
  containerClassname?: string;
};

const CurrencyInput: FC<Props> = ({
  label,
  className,
  placeholder,
  error,
  onChange,
  hasUnit,
  onUnitChange,
  unitValue,
  unitOptions,
  hideCurrency,
  disableUnit,
  explicitRender,
  containerClassname,
  ...props
}) => {
  const [show, setShow] = useState(false);
  const getUnitName =
    (unitOptions ? unitOptions : weightMeasurement).find((item) => item.value === unitValue)
      ?.name || unitValue;

  return (
    <div className={`relative ${containerClassname || ''}`}>
      <label className={`text-[#2E3031] font-medium ${className}`}>
        {label}
        <Input
          {...props}
          prefix={!hideCurrency ? '₦' : ''}
          placeholder={`${!hideCurrency ? '₦' : ''}${placeholder}`}
          decimalsLimit={props.decimalsLimit ?? 2}
          onValueChange={(value) => onChange?.(value ?? '')}
          className={`w-full h-[46px] bg-[#FAFAFA]  z-1 relative focus:outline-none border-b-2 border-[#D5D6D7] py-3  pl-[14px] mt-2 `}
        />
        {hasUnit && (
          <div className='absolute w-[60px] h-[20px] z-10 rounded-[2px] shadow bottom-[20%] right-[5%]'>
            <Dropdown
              visible={show}
              onClickOutside={() => setShow(!show)}
              content={
                <div
                  onClick={() => !disableUnit && setShow(!show)}
                  className={`h-5 p-1 text-[11px] flex justify-between items-center gap-[2px] cursor-pointer unit_dropdown ${
                    disableUnit && '!cursor-not-allowed'
                  }`}>
                  <span className='text-[#6F7376] truncate capitalize'>
                    {explicitRender ? unitValue : getUnitName}
                  </span>
                  {!disableUnit && <ArrowDownIcon className='w-5 h-5 text-[#96999C]' />}
                </div>
              }>
              <DropdownList className='z-[999]'>
                {(unitOptions ? unitOptions : weightMeasurement)?.map((item) => (
                  <DropdownItem
                    key={item.value}
                    onClick={() => {
                      onUnitChange?.(item.value);
                      setShow(!show);
                    }}>
                    {item.name}
                  </DropdownItem>
                ))}
              </DropdownList>
            </Dropdown>
          </div>
        )}
      </label>
      {error && <p className='mt-1 text-[#e60a2b] text-sm'>{error}</p>}
    </div>
  );
};

export default CurrencyInput;
